import { render, staticRenderFns } from "./AddNewGroup.vue?vue&type=template&id=16c5d7c6&scoped=true&"
import script from "./AddNewGroup.vue?vue&type=script&lang=ts&"
export * from "./AddNewGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewGroup.vue?vue&type=style&index=0&id=16c5d7c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5d7c6",
  null
  
)

export default component.exports